/**
 * spiralDrift — gentle spiral feedback in cool blues, very long trails.
 *
 * Uses the `spiral` warp kind (zoom + rotation, no ripple). The rotation is
 * audio-driven only subtly via treble; the centre drifts on a slow sine so
 * the spiral never quite locks.
 */

import { WarpKind, type VisualizerPreset } from '../presetTypes';

export const spiralDriftPreset: VisualizerPreset = {
  id: 'spiralDrift',
  name: 'Spiral Drift',
  seed: {
    kind: 'waveform',
    params: {
      baseY: 0.0,
      gain: 0.45,
      halfThick: 0.011,
      intensity: 0.65,
      color: [0.45, 0.7, 1.0], // cool blue
      edgeSharp: 9.5,
    },
  },
  warp: {
    kind: WarpKind.Spiral,
    params: {
      baseZoom: 0.008,
      bassZoomGain: 0.025,
      rotation: 0.006,
      bassRotationGain: 0.008,
      ripple: 0,
      rippleFreq: 0,
      decay: 0.975, // long trails, well clear of saturation
      chroma: 0.0025,
      hueShift: 0.012,
      beatPunch: 0.04,
      centerDriftAmp: 0.12,
      centerDriftRate: 0.09,
    },
  },
  modulation: [
    {
      target: 'warp.rotation',
      source: 'treble',
      transform: 'linear',
      amount: 0.004,
      smoothingMs: 200,
    },
    {
      target: 'warp.baseZoom',
      source: 'bass',
      transform: 'smoothPulse',
      amount: 0.02,
      smoothingMs: 120,
    },
    {
      target: 'seed.color.r',
      source: 'time',
      transform: 'sine',
      amount: 0.15,
      rate: 0.04,
      offset: 0,
    },
    {
      target: 'seed.color.g',
      source: 'time',
      transform: 'sine',
      amount: 0.1,
      rate: 0.027,
      offset: 0,
    },
  ],
  transition: { durationMs: 1100 },
};
